import { stepConnectorClasses } from '@mui/material/StepConnector'
import { Theme } from '@mui/material/styles'

// ----------------------------------------------------------------------

export default function StepConnector(theme: Theme) {
  return {
    MuiStepConnector: {
      styleOverrides: {
        root: {
          [`&.${stepConnectorClasses.completed}`]: {
            [`& .${stepConnectorClasses.line}`]: {
              borderColor: theme.palette.secondary.main,
            },
          },
          [`&.${stepConnectorClasses.active}`]: {
            [`& .${stepConnectorClasses.line}`]: {
              borderColor: theme.palette.secondary.main,
            },
          },
        },
        alternativeLabel: {
          top: 10,
          left: 'calc(-50% + 16px)',
          right: 'calc(50% + 16px)',
        },
        line: {
          borderColor: theme.palette.divider,
          borderTopWidth: 2,
          borderRadius: 1,
        },
      },
    },
  }
}
